import { Box, Flex } from "rebass/styled-components";
import styled from "styled-components";
import { Subheader } from "../../../../../Components/Text";

export const CreateSignatureCardWrapper: any = styled(Flex)`
  border-radius: 10px 10px 10px 10px;
  padding: 15px;
  flex-direction: column;
  background: linear-gradient(
    123.2deg,
    rgba(189, 153, 239, 0.1) 1.68%,
    rgba(168, 198, 242, 0.1) 97.22%
  );
  border: 2px solid ${(props: any) => props.theme.colors.turboAlpha50};
  position: relative;

  &:hover {
    cursor: pointer;
    .create-signature-hover {
      color: ${({ theme }) => theme.colors.envy};
    }
  }
`;

export const StyledSubheader = styled(Subheader)`
  transition: color 100ms ease;
`;
